import { interval } from 'rxjs';
import { Keepalive } from '@ng-idle/keepalive';
import { filter, Subject, takeUntil } from 'rxjs';
import { vGlobal } from '@core/types/cb-global-vars';
import { Injectable, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { ApiSecurityService, ApiService } from '@core/services/api';
import { SharedService } from "@core/services/shared/shared.service";
import { SignOutService } from 'app/modules/public/sign-out/sign-out.service';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { manageStorageService } from '@core/services/manage-storage/manage-storage.service';
import { ManageTimeSessionComponent } from "@core/components/manage-time-session/manage-time-session.component";
@Injectable()
export class ManageTimeService implements OnDestroy {

  // -----------------------------------------------------------------------------------------------------
  // @ Decorators
  // -----------------------------------------------------------------------------------------------------

  // -----------------------------------------------------------------------------------------------------
  /** constructor  */
  // -----------------------------------------------------------------------------------------------------
  constructor(
    private _idle: Idle,
    public _router: Router,
    private _api: ApiService,
    private _modalTime: MatDialog,
    private _keepalive: Keepalive,
    private _signOutS: SignOutService,
    private _apiS: ApiSecurityService,
    private _sharedInfo: SharedService,
    private _mStorage: manageStorageService
  ) {

    let modalTmSsnCnfig = new MatDialogConfig();
    modalTmSsnCnfig = {
      width: '420px',
      height: '530px',
      data: {},
      disableClose: true,
      autoFocus: false,
      panelClass: 'time-session-dialog'
    }
    /**
    * ----------------------------------------------------------------------------------------------------
    * idle Start
    * ----------------------------------------------------------------------------------------------------
    */

    // sets an idle timeout of 8 minutes , for testing purposes.
    _idle.setIdle(vGlobal.secondsTimeInactive);
    // sets a timeout period of 30 seconds. after 10 seconds of inactivity, the user will be considered timed out.
    _idle.setTimeout(30);
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    _idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    _idle.onIdleEnd.subscribe(() => {
      this.idleState = 'Ahora se encuentra Activo';
      this.status = { state: this.idleState, active: this.hasIdled };
    });

    _idle.onTimeout.subscribe(() => { this.closeSession() });

    _idle.onIdleStart.subscribe(() => {
      this.popRef = this._modalTime.open(ManageTimeSessionComponent, modalTmSsnCnfig);
      this.hasIdled = true;
      this.idleState = 'Te has quedado inactivo!';
      this.status = { state: this.idleState, active: this.hasIdled };
      this._sharedInfo.setData(this.status, 'timeSession')
    });

    _idle.onTimeoutWarning.subscribe((countdown) => {
      this.idleState = 'Pasará el tiempo adentro ' + countdown + ' seg!'
      this.status = { state: this.idleState, active: this.hasIdled, countdown: countdown };
      this._sharedInfo.setData(this.status, 'timeSession')
    });

    // Sets the ping interval to 15 seconds
    _keepalive.interval(15);
    _keepalive.onPing.subscribe(() => this.lastPing = new Date());

    // Lets check the path everytime the route changes, stop or start the idle check as appropriate.
    this._router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      takeUntil(this._unsubscribeMngTime)
    ).subscribe((nvEnd) => {

      let isValidRoute = !this.excludedRoutes.includes(this.pathModule['url']);
      if (isValidRoute) { _idle.watch() }
      else { clearInterval(this.intervalReview); _idle.stop(); }
    });

    this.intervalReview = interval(10000)  // revisa cada 10 seg si ya vencío el tiempo de sesión activo
      .pipe(takeUntil(this._unsubscribeMngTime)) // Automatically unsubscribes on destruction
      .subscribe(value => {
        this.reviewSession(this._mStorage.getPropertie('s_time') ?? "")
      });

  }
  // -----------------------------------------------------------------------------------------------------
  // @ Public declaration vars
  // -----------------------------------------------------------------------------------------------------
  popRef: MatDialogRef<ManageTimeSessionComponent>;
  pathModule: any = this._router;
  currentPath: String;
  idleState = 'Sin Iniciar.';
  lastPing?: Date = null;
  status: any = {};
  hasIdled = false;
  intervalReview: any;
  excludedRoutes = ['/login', '/unblock-user', '/first-access', '/forgot-password']
  // -----------------------------------------------------------------------------------------------------
  // @ Private declaration vars
  // -----------------------------------------------------------------------------------------------------
  private _unsubscribeMngTime: Subject<void> = new Subject();

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------
  ngOnDestroy(): void {
    this._unsubscribeMngTime.next();
    this._unsubscribeMngTime.complete();
  }
  // -----------------------------------------------------------------------------------------------------
  // @ Private methods
  // -----------------------------------------------------------------------------------------------------
  /**
   * ! [reviewSession]
   * runs the process every 8 min
   * check if 8 min have passed in session
   * @param timeStorage 
   */
  private async reviewSession(timeStorage) {

    let isValidRoute = !this.excludedRoutes.includes(this.pathModule['url']);

    if (timeStorage && isValidRoute) {
      let timeLimit = vGlobal.secondsTimeInSession, // 480seg = 8min // 540 seg = 9min
        timeNow = new Date().getTime(), diffTime = ((timeNow - timeStorage) / 1000);

      // if (!environment.destroyOnReload) { console.log((diffTime >= timeLimit), diffTime, timeLimit); }
      if (diffTime >= timeLimit) {
        clearInterval(this.intervalReview);
        this._mStorage.overWritePropertie({ nameStorage: 's_time', valNew: new Date().getTime() }, true)
        try {
          await this.renwJWTSessn();
        } catch (errRenew) { }
      }
    }
  }
  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  public startSession(): void {
    this._idle.watch();
    this.idleState = 'Started.';
    this.status = { state: this.idleState };
    this._sharedInfo.setData(this.status, 'timeSession')
  }


  /**
 * [closeSession]
 */
  closeSession() {
    this._modalTime.closeAll();
    this._api.logOut()
      .then(() => this._signOutS.processToLogOut(), () => this._signOutS.processToLogOut())
      .catch((errLgOut) => { this._signOutS.processToLogOut(); console.error(errLgOut) })
  }


  /**
   * !renew  JWT session 
   * @returns 
   */
  renwJWTSessn() {

    let formData: FormData = new FormData();
    formData.append('refresh_token', this._mStorage.getPropertie('s_refrshTkn'));

    return new Promise<any>((rslvTknRefrsh, rjctTknRefrsh) => {
      this._apiS.poSt("seguridad/oauth2/token/refresh", formData)
        .pipe(
          filter((value) => value !== null),
          takeUntil(this._unsubscribeMngTime)
        )
        .subscribe({
          next: (apiRspnsRefrsh: any) => {
            let infoTkn = apiRspnsRefrsh['data']['token-info'];
            this._mStorage.overWritePropertie({ nameStorage: 's_accsTkn', valNew: infoTkn.access_token }, true);
            this._mStorage.overWritePropertie({ nameStorage: 's_refrshTkn', valNew: infoTkn.refresh_token }, true);
            this._mStorage.overWritePropertie({ nameStorage: 's_time', valNew: new Date().getTime() }, true);
            rslvTknRefrsh(apiRspnsRefrsh);
            console.log('%c🌮 renwTacoSessn', 'color: magenta');
          },
          error: (eRR) => rjctTknRefrsh(false)
        })
    });
  }
}